// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__2P6KA","previous":"Pagination_previous__37CqZ","next":"Pagination_next__3Y6RS"};